import lodash from "lodash";

const state = () => ({
    loading: false,
    singleProduct: null,
    multiProduct: [],
});

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setSingleProduct(state, product) {
        state.singleProduct = product;
    },
    clearSingleProduct(state) {
        state.singleProduct = [];
    },
    clearMultipleProducts(state) {
        state.multiProduct = [];
    },
    addProductToMulti(state, product) {
        state.multiProduct = [...state.multiProduct, product];
    },
    removeSingleFromMultiple(state, product) {
        const copyMultipleProducts = state.multiProduct.filter((elem) => {
            return !lodash.isEqual(elem, product);
        });
        state.multiProduct = copyMultipleProducts;
    },
    addMultiToMulti(state, products) {
        const copyMultipleProducts = [...state.multiProduct];
        const result = lodash.unionWith(
            copyMultipleProducts,
            products,
            lodash.isEqual
        );
        state.multiProduct = result;
    },
    removeMultiFromMulti(state, products) {
        const copyMultipleProducts = [...state.multiProduct];
        const result = lodash.differenceWith(
            copyMultipleProducts,
            products,
            lodash.isEqual
        );
        state.multiProduct = result;
    },
};

const actions = {
    setLoading({ commit }, payload) {
        commit("setLoading", payload.loading);
    },
    setSingleProduct({ commit }, payload) {
        commit("setSingleProduct", payload.product);
    },
    clearSingleProduct({ commit }) {
        commit("clearSingleProduct");
    },
    clearMultipleProducts({ commit }) {
        commit("clearMultipleProducts");
    },
    addProductToMulti({ commit }, payload) {
        commit("addProductToMulti", payload.products);
    },
    removeSingleFromMultiple({ commit }, payload) {
        commit("removeSingleFromMultiple", payload.id);
    },
};

// Getters for the product module
const getters = {
    singleProduct(state) {
        return state.singleProduct;
    },
    multiProduct(state) {
        return state.multiProduct;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
